module.exports = __webpack_public_path__ + "static/media/arrowDown.0cb0ee6b.svg";